module.exports = __webpack_public_path__ + "static/media/Chicken wrap.48a49c91.jpg";